<template>
    <div>
        <div class="row gp-admin">
            <div class="col-sm-6 col-md-4 col-lg-5">
                <div class="card mb-3">
                    <div class="card-header p-2">
                        <div class="input-group" style="border: 1px solid #ced4da;">
                            <div class="input-group-prepend">
                                <span class="input-group-text" style="border: none;">Institución</span>
                            </div>

                            <select class="form-control" id="filtro_institucion_id" v-model="selectedInstitucionId">
                                <option selected disabled value="">Selecciona Institucion...</option>
                                <option v-for="institucion in instituciones" :key="institucion.id" :value="institucion.id">
                                    {{ institucion.text }}
                                </option>
                            </select>

                            <div class="input-group-append">
                                <button class="btn btn-sm btn-secondary" data-toggle="modal" data-target="#CreateGroupModal" :disabled="selectedInstitucionId == ''">Crear grupo</button>
                            </div>
                        </div>
                    </div>

                    <GruposList />
                </div>
            </div>

            <div class="col-sm-6 col-md-8 col-lg-7">
                <Alumnos />
            </div>

        </div>

        <CrearGrupo />
        <EditarGrupo />
        <MigrarAlumnos />
        <CargarAlumnos />
        <CargarProspectos />
    </div>
</template>

<script>
import CrearGrupo from './CrearGrupo';
import EditarGrupo from './EditarGrupo';
import Alumnos from './Alumnos';
import GruposList from './GruposList';
import MigrarAlumnos from './MigrarAlumnos';
import CargarAlumnos from './CargarAlumnos';
import CargarProspectos from './CargarProspectos.vue';
import { mergeMap, pluck, switchMap, startWith, map, tap, share, filter } from 'rxjs/operators';
import { ajax } from 'rxjs/ajax';
import { combineLatest, Subject } from 'rxjs';

export default {
    props: ['instituciones'],
    data() {
        const selectedInstitucionChange$ = this.$watchAsObservable('selectedInstitucionId').pipe(
            map(v => v.newValue)
        );

        const selectedGrupoChange$ = new Subject();
        const loadingGrupos$ = new Subject();
        const gruposRefresh$ = new Subject();
        const grupos$ = combineLatest([
            selectedInstitucionChange$,
            gruposRefresh$.pipe(startWith('')),
        ]).pipe(
            map(values => values[0]),
            tap(_ => loadingGrupos$.next(true)),
            switchMap(institucionId => ajax(`/grupos-administrativos/leerGrupos/${institucionId}`)),
            tap(_ => loadingGrupos$.next(false)),
            map(r => r.response)
        );

        const selectedCicloChange$ = new Subject();
        const loadingCiclos$ = new Subject();
        const ciclos$ = selectedInstitucionChange$.pipe(
            tap(_ => loadingCiclos$.next(true)),
            mergeMap(institucionId => ajax(`/grupos-administrativos/ciclosPorInstitucion/${institucionId}`)),
            tap(_ => loadingCiclos$.next(false)),
            pluck('response'),
            share()
        );

        const loadingProgramas$ = new Subject();
        const programas$ = selectedInstitucionChange$.pipe(
            tap(_ => loadingProgramas$.next(true)),
            switchMap(institucionId => ajax(`/programas/institucion/${institucionId}`)),
            tap(_ => loadingProgramas$.next(false)),
            pluck('response'),
            share()
        );

        const loadingAlumnos$ = new Subject();
        const alumnosRefresh$ = new Subject();
        const alumnos$ = combineLatest([
            selectedGrupoChange$,
            selectedCicloChange$,
            alumnosRefresh$.pipe(startWith(''))
        ]).pipe(
            filter(values => values[0] != null && values[1] != null),
            tap(_ => loadingAlumnos$.next(true)),
            switchMap(values => ajax(`/grupos-administrativos/leerAlumnos/${values[0].id}/ciclo/${values[1].id}`)),
            tap(_ => loadingAlumnos$.next(false)),
            map(resp => resp?.response?.alumnos),
            share()
        );

        return {
            selectedInstitucionId: '',
            gruposRefresh$,
            grupos$,
            loadingAlumnos$,
            alumnosRefresh$,
            alumnos$,
            ciclos$,
            programas$,
            selectedGrupoChange$,
            selectedCicloChange$,
            selectedInstitucionChange$
        }
    },
    provide() {
        return {
            programas$: this.programas$,
            ciclos$: this.ciclos$,
            gruposRefresh$: this.gruposRefresh$,
            grupos$: this.grupos$,
            loadingAlumnos$: this.loadingAlumnos$,
            alumnosRefresh$: this.alumnosRefresh$,
            alumnos$: this.alumnos$,
            selectedGrupoChange$: this.selectedGrupoChange$,
            selectedCicloChange$: this.selectedCicloChange$,
            selectedInstitucionChange$: this.selectedInstitucionChange$
        }
    },
    components: {
        GruposList,
        CrearGrupo,
        Alumnos,
        MigrarAlumnos,
        CargarAlumnos,
        CargarProspectos,
        EditarGrupo
    }
}
</script>

<style lang="scss" scoped>

.list-group-item {
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

</style>>
